export const UploadIcon = ({ size = 16, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" {...props}>
    <path
      fill="#2168D3"
      d="M13.26 14.487H2.74A1.808 1.808 0 0 1 .934 12.68V8.92a.566.566 0 1 1 1.133 0v3.76c0 .367.3.673.673.673h10.514c.366 0 .673-.3.673-.673V8.92a.566.566 0 1 1 1.133 0v3.76c0 .993-.806 1.807-1.806 1.807h.006Z"
    />
    <path
      fill="#2168D3"
      d="M12.374 5.16 8 1.333 3.627 5.16l.747.853 3.06-2.68v6.58a.566.566 0 1 0 1.133 0V3.34l3.06 2.68.747-.853V5.16Z"
    />
  </svg>
);
